﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("Animations", function () {
    var transitionProperties = [
      "height .8s cubic-bezier(.4,.4,.2,1)",
      "margin .8s cubic-bezier(.4,.4,.2,1)",
      "padding .8s cubic-bezier(.4,.4,.2,1)",
      "opacity .4s ease-in-out",
    ];
    var transitionProperty = transitionProperties.join(", ");

    function slideThenFadeIn($el) {
      $el.off("transitionend");

      if ($el.is(":hidden")) {
        $el.css("height", "").css("opacity", "").css("pointer-events", "auto");
        return;
      }

      $el
        .css("transition", transitionProperty)
        .css("height", getParams($el).contentHeight + "px")
        .css("margin", "")
        .css("padding", "");

      $el.on("transitionend", function () {
        $el.css("height", "").css("opacity", "").css("pointer-events", "auto");
      });
    }

    function fadeThenSlideOut($el) {
      $el.off("transitionend");
      $el.css("pointer-events", "none");

      if ($el.css("opacity") === "0") {
        $el.css("height", "0").css("margin", "0").css("padding", "0");
        return;
      }

      $el
        .css("transition", transitionProperty)
        .css("height", getParams($el).visibleHeight + "px")
        .css("opacity", "0");

      $el.on("transitionend", function () {
        $el.css("height", "0").css("margin", "0").css("padding", "0");
      });
    }

    function hide($el) {
      $el.css("height", "0").css("opacity", "0").css("margin", "0").css("padding", "0").css("pointer-events", "none");
    }

    function show($el) {
      $el.css("height", "").css("opacity", "").css("margin", "").css("padding", "").css("pointer-events", "");
    }

    function getParams($el) {
      var $visibleChildren = $el.children().filter(function (index, child) {
        return angular.element(child).css("display") !== "none";
      });

      var childrenTop = $visibleChildren
        .map(function (index, child) {
          return child.getBoundingClientRect().top;
        })
        .toArray();

      var childrenBottom = $visibleChildren
        .map(function (index, child) {
          return child.getBoundingClientRect().bottom;
        })
        .toArray();

      var contentTop = Math.min.apply(null, childrenTop);
      var contentBottom = Math.max.apply(null, childrenBottom);

      return {
        visibleHeight: $el.height(),
        contentHeight: contentBottom - contentTop,
      };
    }

    return {
      slideThenFadeIn: slideThenFadeIn,
      fadeThenSlideOut: fadeThenSlideOut,
      hide: hide,
      show: show,
    };
  });
})(window.angular);
